import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=571acd82&scoped=true&"
import script from "./Tab01.vue?vue&type=script&lang=js&"
export * from "./Tab01.vue?vue&type=script&lang=js&"
import style0 from "./Tab01.scss?vue&type=style&index=0&id=571acd82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571acd82",
  null
  
)

export default component.exports